export enum EnvironmentType {
    local,
    dev,
    qa,
    sandbox,
    staging,
    demo,
    prod
};

export interface IAppConfig {
    environment: string
    environmentName: string
};

export interface IHeaderSettings {
    nonexpandedHeight: string
    expandedHeight: string
};

export function HeaderSettings(): IHeaderSettings {
    const headerSettings: IHeaderSettings = {
        nonexpandedHeight: "5.75em",
        expandedHeight: "8.75em"
    };

    return headerSettings;
}